import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import * as firebase from 'firebase';
import { DateTime } from 'ionic-angular';
import { Globals } from '../../globals';
import { ConfigurationServices } from '../configuration/services';
import { TranslateService } from '@ngx-translate/core';


interface Teacher {
  UID: string;
  name: string;
  email: string;
  school_uid: string;
  user_uid: string;
  created_at: DateTime;
  updated_at: DateTime;
}

interface Classroom {
  UID: string;
  name: string;
  school_uid: string;
  students_list: object;
  teachers_list: object;
  created_at: DateTime;
  updated_at: DateTime;
}

interface Student {
  UID: string;
  name: string;
  email: string;
}

@Injectable()
export class SchoolServices {

  firestore: any;
  //ADD teachers students
  public classroom_teachers_array_tmp = Array();
  public classroom_students_array_tmp = Array();

  constructor(public afs: AngularFirestore,
    public globals: Globals,
    public configurationServices: ConfigurationServices,
    public translate: TranslateService) {
    this.firestore = firebase.firestore();
  }

  //TEACHERS
  public enter_rest: boolean = false;
  teacherCol: AngularFirestoreCollection<Teacher>;
  teachers: Observable<Teacher[]>;
  teacherDoc: AngularFirestoreDocument<Teacher>;
  getTeachers(school_uid) {
    this.teacherCol = this.afs.collection('teachers', ref => ref.where('school_uid', '==', school_uid));
    this.teachers = this.teacherCol.snapshotChanges().map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data() as Teacher;
        data.UID = a.payload.doc.id;
        return data;
      });
    });
  }

  async getTeacher(uid_teacher) {
    const restRef = this.firestore.collection('teachers').doc(uid_teacher);

    var teacher;

    await restRef.get().then(doc => {
      teacher = doc.data();
      teacher.UID = doc.id;
    })

    return teacher
  }

  async getTeacherFromUsers(email) {
    const tsRef = this.firestore.collection('users');

    var teacher;

    await tsRef.where('email', '==', email)
      .get()
      .then(snapshot => {
        snapshot.forEach(doc => {
          teacher = doc.data();
          teacher.UID = doc.id;

        });
      });

    return teacher;
  }

  async addUserInTeachers(name, email, school_uid, user_uid) {
    await this.afs.collection('teachers').add({
      name: name,
      email: email,
      school_uid: school_uid,
      user_uid: user_uid,
      created_at: new Date(),
      updated_at: new Date(),
    }).then(async doc => {

    });
  }

  async deleteTeacher(teacher_uid) {
    this.afs.doc('teachers/' + teacher_uid).delete();
  }

  async deleteTeacherFromUsers(uid_teacher) {
    var teacher = await this.getTeacher(uid_teacher);

    this.afs.doc('users/' + teacher.user_uid).delete();

  }

  async existsTeacher(email) {
    const userRef = this.firestore.collection('users');
    const tRef = this.firestore.collection('teachers');
    var exists_user = false;
    var exists_teacher = false;
    var exists = false;

    var getDoc = await userRef.where('email', '==', email)
      .get()
      .then(snapshot => {
        snapshot.forEach(doc => {
        });
      });

    if (getDoc != undefined) {
      exists_user = true;
    }

    var _getDoc = await tRef.where('email', '==', email)
      .get()
      .then(snapshot => {
        snapshot.forEach(doc => {
        });
      });


    if (_getDoc != undefined) {
      exists_teacher = true;
    }

    if (exists_user && exists_teacher) {
      exists = true;
    }

    return exists;
  }

  //STUDENTS

  studentsCol: AngularFirestoreCollection<Student>;
  students: Observable<Student[]>;
  studentsDoc: AngularFirestoreDocument<Student>;
  getStudents(school_uid) {
    this.studentsCol = this.afs.collection('restaurants', ref => ref.where('school_uid', '==', school_uid));
    this.students = this.studentsCol.snapshotChanges().map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data() as Student;
        data.UID = a.payload.doc.id;
        return data;
      });
    });
  }


  async getClassroomsWithStudentsOfTeacher(school_uid, teacher_uid) {

    const tsRef = this.firestore.collection('classrooms');

    var classrooms = Array();

    await tsRef.where('school_uid', '==', school_uid)
      .get()
      .then(snapshot => {
        snapshot.forEach(doc => {
          var classroom = doc.data();
          classroom.UID = doc.id;

          var t_array = Array();
          for (let k in classroom.teachers_list) {
            t_array.push(classroom.teachers_list[k]);
          }

          var t_index = t_array.findIndex(x => x.uid_teacher == teacher_uid);

          if (t_index >= 0) {
            classroom.href = '#' + classroom.name;
            classrooms.push(classroom);
          }

        });
      });

    return classrooms;

  }

  students_restaurants: any;
  async deleteStudentFromClassroomsAndTeachers(school_uid, uid_restaurant) {
    const tsRef = this.firestore.collection('classrooms');

    await tsRef.where('school_uid', '==', school_uid)
      .get()
      .then(snapshot => {
        snapshot.forEach(async doc => {
          var classroom = doc.data();
          classroom.UID = doc.id;

          /**********************************************/

          /*for (let teacher of this.globals.objectToArray(classroom.teachers_list)) {
            var _ut = await this.getTeacherFromUsers(teacher.email);

            this.students_restaurants = _ut.restaurants;

            let arr = [];
            for (let k in this.students_restaurants) {
              arr.push(this.students_restaurants[k]);
            }

            var _index_res = arr.findIndex(e => e.UID_RESTAURANT === uid_restaurant);

            if (_index_res >= 0) {
              //delete
              arr.splice(_index_res, 1);

              //create of array to object
              const obj = {};
              arr.forEach((item, index) => {
                obj[index] = item;
              })

              this.students_restaurants = obj;

              //update
              await this.configurationServices.afs.collection('users').doc(_ut.UID).update({
                'restaurants': this.students_restaurants,
              })
            }



          }*/

          /**********************************************/

          var t_array = Array();
          for (let k in classroom.students_list) {
            t_array.push(classroom.students_list[k]);
          }

          var t_index = t_array.findIndex(x => x.uid_restaurant == uid_restaurant);

          if (t_index >= 0) {
            //delete teacher and convert to object
            t_array.splice(t_index, 1);

            const obj = {};
            t_array.forEach((item, index) => {
              obj[index] = item;
            })
            //update
            await this.afs.collection('classrooms').doc(classroom.UID).update({
              'students_list': obj,
            });

          }


        });
      });
  }


  async deleteStudentFromUsers(email) {
    var student = await this.getStudentUser(email);

    this.afs.doc('users/' + student.UID).delete();

  }

  async getStudentUser(email) {
    const tsRef = this.firestore.collection('users');

    var student;

    await tsRef.where('email', '==', email)
      .get()
      .then(snapshot => {
        snapshot.forEach(doc => {
          student = doc.data();
          student.UID = doc.id;

        });
      });

    return student;
  }

  async existsStudent(email) {
    const userRef = this.firestore.collection('users');
    const tRef = this.firestore.collection('restaurants');
    var exists_user = false;
    var exists_rest = false;
    var exists = false;

    var getDoc = await userRef.where('email', '==', email)
      .get()
      .then(snapshot => {
        snapshot.forEach(doc => {
        });
      });

    if (getDoc != undefined) {
      exists_user = true;
    }

    var _getDoc = await tRef.where('email', '==', email)
      .get()
      .then(snapshot => {
        snapshot.forEach(doc => {
        });
      });


    if (_getDoc != undefined) {
      exists_rest = true;
    }

    if (exists_user && exists_rest) {
      exists = true;
    }

    return exists;
  }


  //CLASSROOMS
  public classroom_update_state: boolean = false;

  classroomCol: AngularFirestoreCollection<Classroom>;
  classrooms: Observable<Classroom[]>;
  classroomsDoc: AngularFirestoreDocument<Classroom>;
  getClassrooms(school_uid) {
    this.classroomCol = this.afs.collection('classrooms', ref => ref.where('school_uid', '==', school_uid));
    this.classrooms = this.classroomCol.snapshotChanges().map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data() as Classroom;
        data.UID = a.payload.doc.id;
        return data;
      });
    });
  }

  //
  async getClassroom(uid_classroom) {
    const restRef = this.firestore.collection('classrooms').doc(uid_classroom);

    var classroom;

    await restRef.get().then(doc => {
      classroom = doc.data();
      classroom.UID = doc.id;
    })

    return classroom
  }

  //
  async deleteTeachersFromClassrooms(school_uid, teacher_uid) {
    const tsRef = this.firestore.collection('classrooms');

    await tsRef.where('school_uid', '==', school_uid)
      .get()
      .then(snapshot => {
        snapshot.forEach(async doc => {
          var classroom = doc.data();
          classroom.UID = doc.id;

          var t_array = Array();
          for (let k in classroom.teachers_list) {
            t_array.push(classroom.teachers_list[k]);
          }

          var t_index = t_array.findIndex(x => x.uid_teacher == teacher_uid);

          if (t_index >= 0) {
            //delete teacher and convert to object
            t_array.splice(t_index, 1);

            const obj = {};
            t_array.forEach((item, index) => {
              obj[index] = item;
            })

            //classroom.teachers_list = obj;
            //update
            await this.afs.collection('classrooms').doc(classroom.UID).update({
              'teachers_list': obj,
            });

          }

        });
      });
  }

  classroom_restaurants: any;
  async deleteStudentsFromTeacherOfClassroom(classroom_uid) {
    const restRef = this.firestore.collection('classrooms').doc(classroom_uid);

    var classroom;

    await restRef.get().then(async doc => {
      classroom = doc.data();
      classroom.UID = doc.id;

      for (let _teacher of this.globals.objectToArray(classroom.teachers_list)) {

        for (let student of this.globals.objectToArray(classroom.students_list)) {

          var teacher = await this.configurationServices.getUser(_teacher.email);

          this.classroom_restaurants = teacher.restaurants;

          let arr = [];
          for (let k in this.classroom_restaurants) {
            arr.push(this.classroom_restaurants[k]);
          }

          var _index_res = arr.findIndex(e => e.UID_RESTAURANT === student.uid_restaurant);

          if (_index_res >= 0) {
            //delete
            arr.splice(_index_res, 1);

            //create of array to object
            const obj = {};
            arr.forEach((item, index) => {
              obj[index] = item;
            })

            //this.classroom_restaurants = obj;

            //update
            this.configurationServices.afs.collection('users').doc(teacher.UID).update({
              'restaurants': obj,
            })
          }
        }
      }
    })
  }

  deleteClassroom(uid_classroom) {
    this.afs.doc('classrooms/' + uid_classroom).delete();
  }

  async getClassroomsOfTeacher(school_uid) {

    const tsRef = this.firestore.collection('classrooms');

    var classrooms = Array();

    await tsRef.where('school_uid', '==', school_uid)
      .get()
      .then(snapshot => {
        snapshot.forEach(async doc => {
          var classroom = doc.data();
          classroom.UID = doc.id;

          for (let _teacher of this.globals.objectToArray(classroom.teachers_list)) {
            var teacher = await this.getTeacher(_teacher.uid_teacher);
            if (teacher.user_uid == this.globals.user_uid) {
              classroom.total_students = this.globals.objectToArray(classroom.students_list).length;
              classrooms.push(classroom);
            }
          }

        });
      });

    return classrooms;

  }



  /*FUNCTIONS*/
  uid_user: any;
  async createUser(email, name, uid_user, uid_school, rol) {
    //Crear el restaurante y devuelve la uid

    await this.afs.collection('users').add({
      'email': email,
      'name': name,
      'uid_user_auth': uid_user,
      'restaurants': {
        0: {
          'UID_SCHOOL': uid_school,
          'rol': rol,
        }
      }

    }).then(doc => {
      //push
      this.uid_user = doc.id;
    });
  }

  restaurant_uid: any;
  room_uid: any;
  async createRestaurant(name, company, phone, email, school_name, school_uid) {
    //Crear el restaurante y devuelve la uid
    var restaurant: any;

    await this.afs.collection('restaurants').add({
      'license': 'pro',//revisar
      'name': name,
      'company': company,
      'phone': phone,
      'email': email,
      'provider': 'school',
      'school_name': school_name,
      'school_uid': school_uid,
      'number': 1,
      'fiscal_name': '',
      'cif': '',
      'currency': 'Euro (EUR)',
      'tax_name': 'IVA',
      'tax_percentage': '10',
      'timezone': 'Europe/Madrid',
      'tickets': {
        'footer': '',
        'header': {
          'address': true,
          'company': true,
          'email': true,
          'logo': true,
          'phone': true,
        },
        'show_time': true,
      },
      'tutorial': '',
      'created_at': new Date(),
    }).then(async doc => {
      restaurant = doc.id;
      this.restaurant_uid = await doc.id;
    });

    return restaurant;
  }

  async initRestaurant() {
    //insert provider
    await this.afs.collection('providers').add({
      'UID_RESTAURANT': this.restaurant_uid,
      'name': this.translate.instant('general-sin-proveedor'),
      'no_provider': true
    });

    //insert room
    await this.afs.collection('rooms').add({
      'UID_RESTAURANT': this.restaurant_uid,
      'name': this.translate.instant('general-nombre-comedor'),
    }).then(async ref => {
      this.room_uid = ref.id;
    });

    //insert cash
    await this.afs.collection('cashs').add({
      'UID_RESTAURANT': this.restaurant_uid,
      'name': this.translate.instant('general-nombre-caja'),
      'number': 0,
    }).then(async ref => {
      //insert table bar
      await this.afs.collection('tables').add({
        'UID_RESTAURANT': this.restaurant_uid,
        'name': 'bar',
        'type': 'bar',
        'customer': {},
        'ticket': {
          'amount': 0,
          'date': '',
          'list': {},
          'number': '',
          'payment': false,
          'payment_type': '',
          'waiter': '',
          'waiter_uid': '',
          'tip': 0
        },
        'cash_static': this.translate.instant('general-nombre-caja'),
        'cash_uid': ref.id,
        'order': 0,
      })

      //insert table
      await this.afs.collection('tables').add({
        'UID_RESTAURANT': this.restaurant_uid,
        'cash_static': this.translate.instant('general-nombre-caja'),
        'cash_uid': ref.id,
        'name': this.translate.instant('general-mesa-1'),
        'persons': 4,
        'size': '4',
        'state': 'open',
        'customer': {},
        'ticket': {
          'amount': 0,
          'date': '',
          'list': {},
          'number': '',
          'payment': false,
          'payment_type': '',
          'waiter': '',
          'waiter_uid': '',
          'tip': 0
        },
        'type': 'table',
        'uid_room': this.room_uid,
        'order': 0,
      })

    });
  }



  restaurants: any;
  async insertStudentsInTeachers() {
    for (let teacher of this.classroom_teachers_array_tmp) {//for teachers
      //get user teacher
      var _user = await this.configurationServices.getUser(teacher[2]);
      //get user teacher restsaurants
      this.restaurants = _user.restaurants;

      for (let student of this.classroom_students_array_tmp) {//for students


        var _existeix = false;
        //if rest exists in restaurants
        for (let key in this.restaurants) {
          if (this.restaurants[key].UID_RESTAURANT == student[0]) {
            _existeix = true;
          }
        }
        //
        if (_existeix) {
        } else {
          //no exist add to restaurants
          var last_key = Object.keys(this.restaurants)[Object.keys(this.restaurants).length - 1];
          if (last_key == undefined) {
            last_key = '-1';//Iniciamos a 0 si esta undefined
          }

          this.restaurants[Number(last_key) + 1] = {
            'UID_RESTAURANT': student[0],
            'rol': 'admin',
          }
        }
        //


      }
      //update restaurants of user teacher
      this.configurationServices.afs.collection('users').doc(_user.UID).update({
        'restaurants': this.restaurants,
      }).then(() => {
      });
    }


  }



}



// WEBPACK FOOTER //
// ./src/pages/schools/services.ts